export interface IFinancialStatementDefinitionFormModel {
    sheetName: string;
    accountsStartingRow: number;
    accountNameCol: string;
    accountNoCol: string;
    balanceColNo: string;
    previousYearColNo: string;
    shareholderColNo: string | null;
}
